import { CSSProperties } from 'react';
import { Stack, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { Controller, Control, FieldValues } from 'react-hook-form';

import TextFormLabel from '../text/TextFormLabel';
import { useLocalization } from '../../../localization';

export interface CheckboxProps<T extends FieldValues = FieldValues> {
  name: string;
  control: Control<T>;
  label: string;
  disabled?: boolean;
  style?: CSSProperties;
  subLabel?: string;
  rightEl?: React.ReactNode;
}

export const CheckboxField = <T extends FieldValues = FieldValues>(props: CheckboxProps<T>) => {
  const { name, control, label, disabled = false, style, subLabel, rightEl } = props;
  const { t } = useLocalization();

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" gap={2}>
      <Controller
        name={name as any}
        control={control}
        render={({ field: { value, onChange, onBlur } }) => (
          <Stack>
            <FormControlLabel
              control={
                <Checkbox
                  checked={!!value}
                  onChange={e => onChange(e.target.checked)}
                  onBlur={onBlur}
                  disabled={disabled}
                  style={style}
                />
              }
              label={<TextFormLabel label={t(label)} />}
            />
            {subLabel && (
              <Typography variant="body2" color="textSecondary" sx={{ marginLeft: 4 }}>
                {t(subLabel)}
              </Typography>
            )}
          </Stack>
        )}
      />
      {rightEl}
    </Stack>
  );
};
